import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngxs/store';
import { ResetCategories, TopicsState, UpdateCategories } from '../../store';
import { TopicsFilter } from '../../models/topics-filter.model';

@Component({
  selector: 'customer-app-topic-action-bar',
  templateUrl: './topic-action-bar.component.html',
  styleUrls: ['./topic-action-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TopicActionBarComponent {
  private store = inject(Store);

  topicsFilter$ = this.store.select<TopicsFilter>(TopicsState.topicsFilter);

  readonly calendarModification = input(false);

  public updateVisibleTopics(type: string): void {
    this.store.dispatch(new UpdateCategories(type));

    const allOff = this.store.snapshot().topicsState.topicsFilter.categories.every(category => !category.active);

    if (allOff) {
      this.store.dispatch(new ResetCategories());
    }
  }

  public resetCategoryFilter(): void {
    this.store.dispatch(new ResetCategories());
  }
}
